import useEMPPricing from '~/shared/utils/useEMPPricing';
import useMembershipPrice from '~/shared/utils/useMembershipPrice';
import { ProductType } from '~/techstyle-shared/react-products';
import { ProductBaseDto } from '~/techstyle-shared/react-types';

interface UseOutfitSavingsBannerResult {
  showSavingsBanner: boolean;
  outfitValue: number;
  creditCount: number;
  savingsAmount: number;
}

export default function useOutfitSavingsBanner(
  product?: ProductBaseDto
): UseOutfitSavingsBannerResult {
  const { showMemberCredits, tokenValue } = useEMPPricing(product);
  const membershipPrice = useMembershipPrice();
  const isBundle = product?.productTypeId === ProductType.BUNDLE;
  const outfitValue = product?.defaultUnitPrice ?? 0;
  const savingsAmount = outfitValue - parseFloat(membershipPrice) * tokenValue;
  const showSavingsBanner =
    isBundle && showMemberCredits && outfitValue > 0 && savingsAmount > 0;

  return {
    showSavingsBanner,
    outfitValue,
    creditCount: tokenValue,
    savingsAmount,
  };
}
